import React, { Component } from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import * as presentationBuilderDB from '../../database/PresentationBuilderDB';
import './ModalEmail.css';

class ModalCoopEmail extends Component {
  state = {
    templates: [
      { key: 0, value: 'ShareLinkTemplate', text: 'Monthly Social Creative' },
      { key: 1, value: 'LeaseSpecialsTemplate2', text: 'Lease Specials' },
      { key: 2, value: 'SingleAdTemplate', text: 'Single Ad' },
      { key: 3, value: 'CampaignTemplate', text: 'Campaign' }
    ],
    selectedTemplate: 'ShareLinkTemplate',
    emailTemplate: this.props.emailTemplate,
    message: '',
    successMessage: '',
    showPreview: false,
    emailSent: false,
    sendingEmail: false
  };

  componentDidMount() {
    this.setEmailTemplate();
  }

  sendPDF = () => {
    const { sendPDF, user, recipientEmail } = this.props;

    // old way: sendPDF(user.email, notes, coopVar);
    sendPDF({
      recipient: user.email,
      notes: '',
      coopVar: 'coop@constellationagency.com'
    });
    sendPDF({
      recipient: recipientEmail,
      notes: '',
      coopVar: 'coop@constellationagency.com'
    });
    sendPDF({
      recipient: 'coop@constellationagency.com',
      notes: '',
      coopVar: 'coop@constellationagency.com'
    });

    toast('The PDF will be emailed shortly', {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 3000,
      type: toast.TYPE.SUCCESS,
      hideProgressBar: true
    });
  };

  getEmailTemplate = async (templateName) => {
    const client = window.__APOLLO_CLIENT__;
    const queryResult = await client.query({
      query: presentationBuilderDB.EmailTemplateByNameQuery,
      variables: { name: templateName }
    });
    if (
      queryResult.data.emailTemplate !== null &&
      queryResult.data.emailTemplate.nodes[0]
    ) {
      this.setState({
        emailTemplate: queryResult.data.emailTemplate.nodes[0].content
      });
    }
  };

  setEmailTemplate = () => {
    const currentTemplateSelection = this.props.coopTypeSelection;
    const foundTemplate = this.state.templates.find((template) => {
      return template.text === currentTemplateSelection;
    });
    if (foundTemplate) {
      this.setState({ selectedTemplate: foundTemplate.value });
    }
  };

  render() {
    const {
      coopAdAccount,
      coopMonth,
      coopTypeSelection,
      userName,
      recipientEmail,
      closeCoopModal
    } = this.props;
    const { emailSent } = this.state.emailSent;

    return (
      <div>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <h4 className="preview-title">Preview Email</h4>
              <h5>
                Sending to: <u>{recipientEmail}</u>
              </h5>
              <hr />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <div>
                <p>Hello,</p>
                <p>
                  The PDF of the{' '}
                  <b>
                    {coopAdAccount} {coopTypeSelection}
                  </b>{' '}
                  for {coopMonth} - 2021 for pre-approval can be found below.
                </p>
                <p>
                  You can download it <a>here</a>.
                </p>
                <p>Thank you for reviewing!</p>
                <p>Best,</p>
                <strong>{userName}</strong>
              </div>
            </Grid.Column>
          </Grid.Row>

          <br />

          <Grid.Row>
            <Grid.Column>
              <hr />
              <div className="model-buttons-container">
                <Form.Button
                  size="small"
                  floated="left"
                  color="grey"
                  onClick={closeCoopModal}
                >
                  Close
                </Form.Button>
                {!emailSent ? (
                  <Form.Button
                    size="small"
                    floated="left"
                    color="blue"
                    onClick={this.sendPDF}
                  >
                    Send
                  </Form.Button>
                ) : (
                  <Form.Button
                    size="small"
                    floated="left"
                    color="grey"
                    onClick={closeCoopModal}
                  >
                    Close
                  </Form.Button>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <p>
                <b>
                  DO NOT SEND UNLESS YOU ARE REALLY SURE. WE SHOULD NOT SPAM.
                </b>
              </p>
              <p>
                <i>
                  Note: The pdf will automatically be sent in the email through
                  a link!
                </i>
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default ModalCoopEmail;



// WEBPACK FOOTER //
// ./src/screens/Presentation/ModalCoopEmail.js